/**
 * Protected Login Route Component
 * Redirects authenticated users away from login/signup pages
 */
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import authService from "../services/authService";

export default function ProtectedLoginRoute({ children, userType = 'user' }) {
  const location = useLocation();
  
  // Check if user is already authenticated
  const isUserAuthenticated = authService.isUserAuthenticated();
  const isAdminAuthenticated = authService.isAdminAuthenticated();
  
  // If user is authenticated, redirect to appropriate dashboard
  if (userType === 'user' && isUserAuthenticated) {
    // Check if trying to access signin/signup while logged in as user
    if (location.pathname === '/signin' || location.pathname === '/signup') {
      return <Navigate to="/user/dashboard" replace />;
    }
  }
  
  if (userType === 'admin' && isAdminAuthenticated) {
    // Check if trying to access admin login while logged in as admin
    if (location.pathname === '/admin/login') {
      return <Navigate to="/admin/dashboard" replace />;
    }
  }
  
  // If both are authenticated, redirect based on current path
  if (isUserAuthenticated && location.pathname.startsWith('/admin/login')) {
    return <Navigate to="/user/dashboard" replace />;
  }
  
  if (isAdminAuthenticated && (location.pathname === '/signin' || location.pathname === '/signup')) {
    return <Navigate to="/admin/dashboard" replace />;
  }
  
  // Allow access to login page if not authenticated
  return children;
}

